// React
import { useState } from "react";
// MUI
import { Button, Stack } from "@mui/material";
import { LoadingButton } from "@mui/lab";

// Components
import SimpleTextField from "@Layouts/components/InputComponents/SimpleTextField";

// Types
import { ButtonClasses } from "@mui/material/Button/buttonClasses";

type SingleTokenFieldVariant = Readonly<{
	isLoading: boolean;
	disabled: boolean;
	placeholder?: string;
	isError?: boolean;
	error?: Error | null;
	inputProps?: {
		classes?: string;
	};
	buttonType?: "submit" | "button";
	buttonClasses?: Partial<ButtonClasses>;
	buttonProps?: {
		classes?: string;
	};
	// Callbacks
	onSubmit?: () => void;
}>;

export default function SingleTokenFieldVariant(props: SingleTokenFieldVariant) {
	const { placeholder = "Token", error = null, isError = false } = props;

	const [token, setToken] = useState("");

	return (
		<Stack spacing={isError ? 1 : 4} mt={4}>
			<SimpleTextField
				text={token}
				editable
				autoFocus
				outlined
				placeholder={placeholder}
				inputProps={props.inputProps}
				type="input"
				name="token"
				onChange={(value) => setToken(value)}
			/>
			<Stack className="text-center" sx={{ display: isError ? "block" : "none" }}>
				<span className="alert-message">{error?.message}</span>
			</Stack>
			{props.isLoading ? (
				<LoadingButton loading variant="outlined" className={"!bg-[#cccccc] !h-[30px] !border-0"} />
			) : (
				<Button
					variant="contained"
					type={props.buttonType ?? "submit"}
					fullWidth
					disabled={props.disabled || !token}
					classes={props.buttonClasses}
				>
					Log in
				</Button>
			)}
		</Stack>
	);
}
